<template>
    <div v-if="showInfoModal">
        <div class="popupModal" :class="{active: showInfoModal}">
            <div class="popupModal__wrapper" @click="outsideAreaClickAnalytic">
                <div class="popupModal__content">
                    <div class="main-content">
                        <h3 class="main-content__title">{{settings.title}}</h3>
                    </div>
                    <template>
                        <div class="buttons__wrapper">
                            <div class="snap-button" @click="settings.onSnapPictureHandler()">
                                {{ translate ('snapPictureButton') }}
                            </div>
                            <div class="cancel-button" @click="settings.onCancelHandler()">
                                {{translate ('snapPicturePopupContinue')}}
                            </div>
                        </div>
                    </template>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import logAnalyticsEvent from '@/helpers/analytics'
    import errorMixin from '@/mixins/errorMixin';


    export default {
        name: "explainGeolactionPopup",

        mixins: [mixin, errorMixin],

        data() {
            return {
                showInfoModal: this.settings !== null,
            }
        },

        watch: {
            settings(newValue) {
                this.showInfoModal = newValue !== null
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        methods: {
            outsideAreaClickAnalytic () {
                logAnalyticsEvent(`snap_picture_popup_outside_area_clicked`)
            }
        }

    }
</script>

<style scoped>
    .main-content {
        text-align: center;
        color: black;
        margin-bottom: 25px;
        margin-top: 25px;
    }

    .main-content__title {
        margin-top: 0;
        color: black;
        margin-bottom: 0px;
        max-width: 250px;
        font-size: 20px;
    }
    .buttons__wrapper {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        padding: 20px;
    }
    .snap-button {
        background-color: #3F405C;
        color: white;
        padding: 15px;
        text-align: center;
        border-radius: 6px;
        width: 100%;
        cursor: pointer;
    }
    .cancel-button {
        margin-top: 15px;
        border: 2px solid #3F405C;
        border-radius: 6px;
        width: 100%;
        padding: 15px;
        text-align: center;
        cursor: pointer;
    }


</style>